import React from "react";
import BeneficariesView from "../BeneficariesView/BeneficariesView";
import Icon1 from "../../images/gbrFarmerBenefits/pay-per-click.svg";

// Component representing the role of a Plant Manager / Supervisor
const PlantManager = () => {
  // Features highlighting key responsibilities and capabilities
  const features = [
    {
      image: Icon1,
      title: "End-to-End Production Oversight",
      bodycopy:
        "Real-time visibility into plant operations, workforce efficiency, and production progress.",
    },
    {
      image: Icon1,
      title: "Workforce & Task Management",
      bodycopy:
        "Assign, monitor, and optimize worker schedules and task execution with digital tools.",
    },
    {
      image: Icon1,
      title: "Quality Control & Compliance Tracking",
      bodycopy:
        "Ensure adherence to food safety and industry standards with automated quality checks.",
    },
    {
      image: Icon1,
      title: "Resource & Inventory Optimization",
      bodycopy:
        "Monitor raw material usage, minimize waste, and manage inventory efficiently.",
    },
    {
      image: Icon1,
      title: "Production Analytics & Reporting",
      bodycopy:
        "Generate data-driven insights for process improvements and strategic decision-making.",
    },
  ];

  // Benefits of adopting the Plant Manager role
  const benefits = [
    {
      image: Icon1,
      title: "Higher Operational Efficiency",
      bodycopy:
        "Improves workflow coordination, reducing downtime and maximizing output.",
    },
    {
      image: Icon1,
      title: "Enhanced Quality & Compliance",
      bodycopy:
        "Ensures production meets safety and regulatory standards, reducing risks.",
    },
    {
      image: Icon1,
      title: "Improved Workforce Productivity",
      bodycopy:
        "Optimized task assignments lead to better workforce engagement and output.",
    },
    {
      image: Icon1,
      title: "Cost Savings & Waste Reduction",
      bodycopy:
        "Better resource management leads to lower costs and minimized production waste.",
    },
    {
      image: Icon1,
      title: "Faster & Informed Decision-Making",
      bodycopy:
        "Access to real-time data enables quicker responses to operational challenges.",
    },
  ];

  return (
    <>
      {/* Component to display the banner, features and benefits */}
      <BeneficariesView title="Plant Manager / Supervisor" features={features} benefits={benefits} />
    </>
  );
};

export default PlantManager;

